import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';
import ContextMenu from 'Common/Components/ContextMenu';
import MenuItem from 'Common/Components/ContextMenu/components/MenuItem';
import { TriggerButton } from './styled';

const CVEActionMenu = ({
  cve,
  onEdit,
  canEdit,
  variant,
  fullWidth
}) => {
  const [showMenu, setShowMenu] = useState(false);
  const [xPos, setXPos] = useState(0);
  const [yPos, setYPos] = useState(0);

  const displayMenu = useCallback((show, nextXPos = null, nextYPos = null) => {
    setShowMenu(show);
    if (typeof nextXPos === 'number') setXPos(nextXPos);
    if (typeof nextYPos === 'number') setYPos(nextYPos);
  }, []);

  const handleOpenMenu = useCallback((event) => {
    event.preventDefault();
    event.stopPropagation();
    displayMenu(true, event.clientX, event.clientY);
  }, [displayMenu]);

  const handleEdit = useCallback((event) => {
    if (event && typeof event.stopPropagation === 'function') event.stopPropagation();
    displayMenu(false);
    if (typeof onEdit === 'function') onEdit();
  }, [displayMenu, onEdit]);

  const handleOpenWebsite = useCallback((event) => {
    if (event && typeof event.stopPropagation === 'function') event.stopPropagation();
    displayMenu(false);

    if (typeof window === 'undefined') return;

    window.open(
      `https://www.cve.org/CVERecord?id=${String(cve ?? '').toUpperCase()}`,
      '_blank',
      'noopener,noreferrer'
    );
  }, [cve, displayMenu]);

  const contextMenu = (
    <ContextMenu
      show={ showMenu }
      xPos={ xPos }
      yPos={ yPos }
      displayFunction={ displayMenu }
      zIndex={ 100000 }
    >
      <>
        {canEdit && <MenuItem title="Edit" onClick={ handleEdit } />}
        <MenuItem title="Go to website" onClick={ handleOpenWebsite } />
      </>
    </ContextMenu>
  );

  return (
    <>
      <TriggerButton
        type="button"
        variant={ variant }
        fullWidth={ fullWidth }
        title={ cve }
        onClick={ handleOpenMenu }
      >
        {cve}
      </TriggerButton>
      {showMenu && (
        typeof document === 'undefined'
          ? contextMenu
          : createPortal(contextMenu, document.body)
      )}
    </>
  );
};

CVEActionMenu.propTypes = {
  cve: PropTypes.string.isRequired,
  onEdit: PropTypes.func,
  canEdit: PropTypes.bool,
  variant: PropTypes.oneOf(['detail', 'table']),
  fullWidth: PropTypes.bool
};

CVEActionMenu.defaultProps = {
  onEdit: () => {},
  canEdit: true,
  variant: 'detail',
  fullWidth: false
};

export default CVEActionMenu;
